<template>
  <v-dialog width="100%" max-width="1200px" persistent v-model="show">
    <v-card>
      <v-overlay
        v-model="overlay"
        contained
        class="align-center justify-center"
        persistent
      >
        <v-card max-width="500px" class="mx-auto" style="overflow: hidden">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-row justify="center" align-content="center" style="height: 100%">
              <v-col cols="12">
                <v-progress-circular
                  v-show="!isProductPublished"
                  model-value="10"
                  :indeterminate="true"
                ></v-progress-circular>
                {{ savingText }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row v-show="isProductPublished">
              <v-col>
                <v-btn @click="closeDialog" block>Закрыть</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-overlay>
      <v-card-title
        >{{ title }} <v-spacer />
        <v-btn icon flat @click="closeDialog"><v-icon icon="$close" /></v-btn>
      </v-card-title>
      <v-card-text class="tab-content">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-tabs v-model="tab" fixed-tabs>
            <v-tab value="step1"> Шаг 1 </v-tab>
            <v-tab value="step2" :disabled="isStep2Disabled"> Шаг 2 </v-tab>
          </v-tabs>
          <v-window v-model="tab">
            <v-window-item :value="'step1'">
              <div>
                <v-row>
                  <v-col cols="12">
                    <v-list>
                      <v-list-group
                        v-for="item in properties"
                        :key="item.categoryId"
                      >
                        <template v-slot:activator="{ props }">
                          <v-list-item
                            v-bind="props"
                            :title="item.categoryName"
                            class="p-0"
                          >
                          </v-list-item>
                        </template>
                        <v-list-item>
                          <v-data-table
                            :headers="headers"
                            :items="item.properties"
                            v-model="selected"
                            show-select
                            fixed-header
                            height="400px"
                            :items-per-page="100"
                          >
                            <template v-slot:item.propNameRus="{ item }">
                              <v-tooltip
                                text="Характеристика уже связана."
                                location="top"
                              >
                                <template v-slot:activator="{ props }">
                                  <v-btn
                                    v-bind="props"
                                    flat
                                    icon="$mdiAlert"
                                    :color="'red'"
                                    size="x-small"
                                    v-show="!item.value.isNewProp"
                                  >
                                  </v-btn>
                                </template>
                              </v-tooltip>
                              <span style="padding-left: 10px">{{
                                item.value.propNameRus
                              }}</span>
                            </template>

                            <template v-slot:item.id="{ item }">
                              <v-select
                                v-model="item.value.propRelationSelected"
                                :items="item.value.similarProperties"
                                item-title="title"
                                item-value="id"
                                :disabled="!item.value.isNewProp"
                              >
                              </v-select>
                            </template>
                          </v-data-table>
                        </v-list-item>
                      </v-list-group>
                    </v-list>
                  </v-col>
                </v-row>
              </div>
            </v-window-item>
            <v-window-item :value="'step2'">
              <div>
                <v-row>
                  <v-col cols="3"
                    ><v-text-field
                      v-model="search"
                      label="Найти товар"
                      :prepend-inner-icon="'$mdiMagnify'"
                      variant="outlined"
                      hide-details
                      single-line
                    ></v-text-field
                  ></v-col>
                  <v-col cols="3">
                    <v-checkbox
                      label="100% новый товар"
                      hide-details="auto"
                      v-model="allProductsIsNew"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="3" align="center"
                ><v-autocomplete
                  :items="subcategories"
                  item-title="text"
                  item-value="value"
                  multiple
                  label="Выберите подкатегории поиска"
                  v-model="selectedSubcategories"
                ></v-autocomplete
              ></v-col>
              <v-col cols="3"
            ><v-btn
              block
              class="bg-primary"
              :disabled="loading"
              @click=" getGoodsStock()"
              >поиск</v-btn
            ></v-col
          >
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="headersProducts"
                      :items="products"
                      :search="search"
                      v-model="selectedProducts"
                      show-select
                      fixed-header
                      height="350px"
                      :items-per-page="100"
                    >
                      <template v-slot:item.similarProducts="{ item }">
                        <v-text-field placeholder="Уточняющий поиск" @input="searchByTerm($event, item, supplierCategoryId)"></v-text-field>
                        <v-autocomplete
                          v-model="item.value.selectedProductId"
                          :items="item.value.similarProducts"
                          item-title="title"
                          item-value="id"
                          :disabled="allProductsIsNew"
                        >
                        </v-autocomplete>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-window-item>
          </v-window>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row v-if="tab == 'step1'">
          <v-spacer />
          <v-col cols="3"
            ><v-btn block @click="closeDialog">Закрыть</v-btn></v-col
          >
          <v-col :cols="anyPropertiesAreAssigned ? '4' : '3'"
            ><v-btn
              block
              @click="toStep2()"
              class="bg-primary"
              :disabled="loading || isStep2Disabled"
              >{{ step2ButtonTitle }}</v-btn
            ></v-col
          >
        </v-row>
        <v-row v-if="tab == 'step2'">
          <v-spacer />
          <v-col cols="3"
            ><v-btn block @click="toStep1()">К шагу 1</v-btn></v-col
          >
          <v-col cols="3"
            ><v-btn
              block
              class="bg-primary"
              :disabled="loading"
              @click="saveAndPublish()"
              >Сохранить</v-btn
            ></v-col
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SupplierApiRepository = RepositoryFactory.get("supplierApi");
const SupplierCategoryRepository = RepositoryFactory.get("supplierCategory");
const SupplierGoodsStockRepository =
  RepositoryFactory.get("supplierGoodsStock");
const SubcategoryRepository = RepositoryFactory.get("subCategory");
const FIRST_STEP = "step1";
const SECOND_STEP = "step2";

export default {
  data() {
    return {
      show: false,
      title: "Публикация характеристик и товаров категории",
      valid: true,
      properties: [],
      relatedCategory: {},
      isCreateNewCategory: false,
      selected: [],
      supplierCategoryId: null,
      supplierId: null,
      loading: false,
      tab: "step1",
      headers: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "propNameRus",
        },
        {
          title: "Свойства категории",
          align: "start",
          sortable: false,
          key: "id",
        },
      ],
      products: [],
      selectedProducts: [],
      headersProducts: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "name",
        },
        {
          title: "Похожие товары",
          align: "start",
          sortable: false,
          key: "similarProducts",
        },
        {
          title: "Товары на складе поставщика",
          align: "start",
          sortable: false,
          key: "inStock",
        },
        {
          title: "Товары в резерве поставщика",
          align: "start",
          sortable: false,
          key: "inReserve",
        },
      ],
      overlay: false,
      savingText: "Выполняется шаг1...",
      isProductPublished: false,
      allProductsIsNew: false,
      search: "",
      subcategories:[],
      selectedSubcategories: []
    };
  },
  watch: {
    tab() {
      if (this.tab && this.tab == "step2" && !this.products.length) {
        this.getSubcategoriesForSelect();
        //this.getGoodsStock();
      }
    },
  },
  methods: {
    async openDialog(categoryId, supplierId) {
      this.properties = [];
      this.products = [];
      this.selected = [];
      this.selectedProducts = [];
      this.loading = true;
      this.show = true;
      this.supplierCategoryId = categoryId;
      this.supplierId = supplierId;
      const response = await SupplierApiRepository.getCategoriesProperties(
        categoryId
      );
      if (response && response.data.status === "success") {
        this.properties = response.data.data;
      }
      this.loading = false;
    },
    closeDialog() {
      this.overlay = false;
      this.loading = false;
      this.show = false;
      this.properties = [];
      this.products = [];
      this.tab = "step1";
    },
    async saveCategoryProperties() {
      this.loading = true;
      let response = await SupplierCategoryRepository.saveCategoryProperties(
        this.selected,
        this.supplierId,
        this.supplierCategoryId
      );
      if (response && response.data.status === "success") {
        this.$emit("update");
      }
      this.loading = false;
    },
    async getSubcategoriesForSelect() {
      const result = await SubcategoryRepository.getCategoriesForSelect();
      if (result) {
        if (result.data.status === "success") {
          this.subcategories = result.data.data;
        }
      }
    },
    async getGoodsStock() {
      this.loading = true;
      const response =
        await SupplierGoodsStockRepository.getCategoryGoodsWithSimilars(
          this.supplierCategoryId, this.selectedSubcategories
        );
      if (response && response.data.status === "success") {
        this.products = response.data.data;
      }
      this.selectedSubcategories = []
      this.loading = false;
    },
    toStep2() {
      this.tab = SECOND_STEP;
    },
    toStep1() {
      this.tab = FIRST_STEP;
    },
    async saveAndPublish() {
      this.overlay = true;
      let response = null;

      if (this.selected.length || this.anyPropertiesAreAssigned) {
        response = await SupplierCategoryRepository.saveCategoryProperties(
          this.selected,
          this.supplierId,
          this.supplierCategoryId
        );
      }

      if (
        (response && response.data.status === "success") ||
        this.anyPropertiesAreAssigned
      ) {
        this.savingText = "Выполняется шаг2...";
        //this.$emit("update");
        const productsForPublish = this.selectedProducts.map((x) => {
          return {
            stockProductId: x.productId,
            selectedRelationProductId: x.selectedProductId,
          };
        });
        const productPublishResponse =
          await SupplierGoodsStockRepository.publishGoods(
            this.supplierCategoryId,
            productsForPublish,
            this.allProductsIsNew
          );
        if (
          productPublishResponse &&
          productPublishResponse.data.status == "success"
        ) {
          this.savingText = "Публикация выполнена.";
          this.isProductPublished = true;
        }
      }
    },

    async searchByTerm(event, item, supplierCategoryId){
      if(event && event.target.value.length > 3){
        const response = await SupplierGoodsStockRepository.searchByWord(this.supplierCategoryId, item.value.productId, event.target.value);
        if (response && response.data.status === "success") {
          const foundedProducts = response.data.data.similarProducts.reduce((acc, current) => {
            const isInArr2 = item.value.similarProducts.some(obj => obj.id === current.id);
            
            if (!isInArr2) {
              acc.push(current);
            }
            
            return acc;
          }, []);

          if(foundedProducts.length){
            item.value.similarProducts.push(...foundedProducts);
          }
        }
      }
      
    }
  },
  computed: {
    isStep2Disabled: {
      get() {
        if (this.anyPropertiesAreAssigned) {
          return false;
        }
        return !this.selected.length;
      },
    },
    anyPropertiesAreAssigned: {
      get() {
        const categoryProperties = this.properties.find(
          (it) => it.categoryId === this.supplierCategoryId
        );
        if (!categoryProperties) {
          return false;
        }
        return (
          categoryProperties.properties.filter((item) => !item.isNewProp)
            .length > 0
        );
      },
    },
    step2ButtonTitle: {
      get() {
        return this.anyPropertiesAreAssigned
          ? "Пропустить данный шаг"
          : "Далее";
      },
    },
  },
};
</script>
<style scoped>
.v-card-title {
  padding: 0 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: center !important;
}
.v-list-group__items .v-list-item {
  padding-inline-start: 20px !important;
}

.tab-content {
  height: 600px;
  overflow-y: auto;
}
.v-card-actions .v-btn {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));
}
</style>
